import React, { useEffect, useState } from 'react';
import { Avatar, Chip, Grid, makeStyles, Typography } from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import axiosInstance, { FACULTY_API_URL, EVENT_IMG } from '../constatns';
import Flicking, { ViewportSlot } from '@egjs/react-flicking';
import '@egjs/flicking-plugins/dist/pagination.css';
import '@egjs/react-flicking/dist/flicking.css';
import '@egjs/react-flicking/dist/flicking-inline.css';
import { AutoPlay, Arrow, Pagination } from '@egjs/flicking-plugins';
import '@egjs/flicking-plugins/dist/arrow.css';
import { InvirtedSpeakers } from '../program/trySpeakerId';

// import Stack from '@mui/material/Stack';
import './MainSpeakersComponent.css';

import { SpeakerData } from '../program/SpeakerData';

const styles = makeStyles((theme) => ({
  container: {
    width: '100%',
    display: 'flex',
    height: 'fit-content',
    flexDirection: 'row',
    '& > div:first-child': {
      width: '50%',
      marginRight: '5px',
      backgroundImage: `url('${EVENT_IMG}/speaker_bg.png')`,
      backgroundRepeat: 'no-repeat',
      borderRadius: '5px',
    },
    '& > div:last-child': {
      width: '50%',
      backgroundImage: `url('${EVENT_IMG}/main_is_bg.png')`,

      backgroundRepeat: 'no-repeat',
      borderRadius: '5px',
    },
    // '& > div': {
    // margin: '5px',
    // },
  },
  category: {
    color: '#fff',
    fontSize: 'x-large',
    fontWeight: 'bold',
    // padding: theme.spacing(2, 0),
    padding: '16px 0',
    textAlign: 'center',
    borderBottom: '1px solid #fff',
  },
  speakerWrap: {
    display: 'flex',
    flexDirection: 'row',
    // flexDirection: 'column',
    // alignItems: 'center',
    // justifyContent: 'center',
    justifyContent: 'start',
    height: '100%',
    justifyContentItems: 'center',
    // padding: '30px 10px',
    paddingTop: '5px',

    '& > div:not(:last-child)': {
      marginRight: '3px',
    },
  },
  speakerDiv: {
    width: 'calc(100% / 3)',
    // width: '40%',
    '& > div:first-child': {
      alignItems: 'center',
      backgroundColor: 'transparent',
      display: 'flex',
      flexDirection: 'column',
      height: '4.2em',
      justifyContent: 'center',
      // backgroundColor: theme.palette.primary.main,
      fontWeight: 'bold',
      //   marginBottom: '0.7em',
      '& p': {
        textAlign: 'center',
        color: '#fff',
      },
    },
    '& > div:not(:first-child)': {
      display: 'flex',
      flexDirection: 'row',
      minHeight: '120px',
      '& p': {
        lineHeight: 1.3,
      },
    },
    '& img': {
      maxWidth: '80px',
    },
  },
  speakerDesc: {
    // paddingTop: '0.5em',
    // paddingLeft: '0.5em',
    padding: '0.5em',
    color: '#555',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
      display: '-ms-flexbox',
      msFlexDirection: 'column',
      flex: '1 1 0%',
    },
  },
  speakerBox: {
    display: 'flex',
    width: 'calc(100% / 3)',
    maxHeight: '180px',
    padding: '3px',
    '& img': {
      // maxWidth: '124px',
      // minHeight: '157px',

      maxWidth: '89px',
      minHeight: '121px',
      minWidth: '89px',
      maxHeight: '121px',
      objectFit: 'cover',
    },
  },
  speakerOuter: {
    display: 'flex',
    flexDirection: 'column',
  },
  noImgBox: {
    minWidth: '89px',
    minHeight: '121px',
    border: '1px solid rgba(38, 38, 38, 0.05)',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    '& > img': {
      width: '70%',
      maxWidth: '70%',
      minHeight: 'auto',
    },
  },
}));

const MainSpeakersComponent = (props) => {
  const classes = styles();
  const [speakerList, setSpeakerList] = useState([]);

  useEffect(() => {
    getSpeakerList();
  }, []);

  const getSpeakerList = () => {
    axiosInstance.get(`${FACULTY_API_URL}/speaker/prs`).then((res) => {
      let data = res.data;

      data.sort(function (a, b) {
        return parseInt(a.no) > parseInt(b.no) ? 1 : -1;
      });

      data = data.filter((data) => {
        return data.country !== 'Korea';
      });

      // console.log(data);
      setSpeakerList(data.filter((d) => d.country !== 'Korea'));
    });
  };

  // 메인 연자 정보 표시
  const renderInvitedSpeakers = (datas) =>
    datas.map((data, idx) => {
      return (
        <Grid container justifyContent="center" key={`${data.name}_${idx}`} item xs={4}>
          <Grid container item xs={11} xl={10}>
            <Grid container>
              <Chip
                label={data.type}
                style={{
                  backgroundColor: data.color,
                  color: '#fff',
                  width: '100%',
                  fontSize: 'large',
                  fontWeight: 'bold',
                  marginBottom: 16,
                  boxShadow: '0.5px 0.5px 0.5px 0.5px #efefef',
                }}
              />
            </Grid>
            <Grid
              container
              justifyContent="center"
              style={{
                backgroundColor: '#fff',
                borderRadius: '10px',
                // height: window.matchMedia('(max-width:1280px)').matches ? '360px' : 'fit-content',
              }}
            >
              <Grid container justifyContent="center" item xs={10} style={{ paddingBottom: 16, minHeight: 260 }}>
                <Avatar
                  alt={data.name}
                  src={`https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/program/speakers/${data.image}`}
                  style={{ width: '130px', height: '130px', margin: '8px 0', border: '1px solid #efefef' }}
                />
                <Grid container justifyContent="center">
                  <Grid container>
                    <Typography style={{ fontSize: 'large', fontWeight: 'bold', color: '#555555' }}>{data.name}</Typography>
                  </Grid>
                  <Grid container>
                    <Typography dangerouslySetInnerHTML={{ __html: data.affiliation }} style={{ color: '#555555', fontSize: 'medium' }} />
                  </Grid>
                  <Grid container>
                    <Typography style={{ color: '#000000', fontFamily: 'Roboto-Regular', fontStyle: 'italic' }}>{data.country}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    });

  //초대 연자 정보 표시
  const renderSpeakers = (datas) => {
    let speakers = [];
    return (
      <>
        {datas.map((speaker, idx) => {
          speakers.push(
            <Grid
              container
              justifyContent="center"
              alignItems="flex-start"
              item
              xs={12}
              md={6}
              key={`speaker-${speaker.name}_${idx}`}
              style={{ height: '100%' }}
            >
              <Grid container justifyContent="center" style={{ width: 300, height: 167, marginTop: 72 }}>
                <div style={{ width: 130, height: '100%' }}>
                  {speaker.noPic !== true ? (
                    <img
                      src={`https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/program/speakers/pic/${speaker.name}.png`}
                      alt={speaker.name}
                      style={{ width: '100%', height: '100%', borderRadius: 10, backgroundColor: '#fff' }}
                    />
                  ) : (
                    <img src={'images/PRS2022/no_img_2022.png'} alt="noImg" style={{ width: '100%', height: '100%', borderRadius: 10 }} />
                  )}
                </div>
                <div style={{ width: 170, height: '100%', paddingLeft: 10 }}>
                  <Grid container>
                    {speaker.name.split('^').map((text, idx) => {
                      return (
                        <Typography
                          key={`${text}_${idx}`}
                          style={{ fontSize: 18, fontWeight: 'bold', color: '#ffffff', lineHeight: 1, paddingTop: 10 }}
                        >
                          {text}
                        </Typography>
                      );
                    })}
                  </Grid>
                  <Grid container style={{ padding: '10px 0' }}>
                    <Typography
                      style={{ fontSize: 16, color: '#efefef', lineHeight: 1.3 }}
                      dangerouslySetInnerHTML={{ __html: speaker.affiliation }}
                    />
                  </Grid>
                  <Grid container>
                    <Typography style={{ fontSize: 16, color: '#efefef', fontFamily: 'Roboto-Regular', fontStyle: 'italic' }}>
                      {speaker.country}
                    </Typography>
                  </Grid>
                </div>
              </Grid>
            </Grid>,
          );

          // Flicking 한 슬라이드당 표시 정보 갯수
          if (speakers.length === 2) {
            let _speakers = [...speakers];
            speakers = [];
            return (
              <Grid container alignItems="center">
                {_speakers}
              </Grid>
            );
          }
          if (idx === datas.length - 1) {
            return speakers;
          }
        })}
      </>
    );
  };

  const _plugins = [
    new Arrow({ parentEl: document.body }),
    new Pagination({ type: 'bullet' }),
    new AutoPlay({
      duration: 5000,
      direction: 'NEXT',
      stopOnHover: false,
    }),
  ];
  return (
    <>
      <Grid container justifyContent="center">
        <div className={classes.container}>
          <div className={classes.speakerOuter}>
            <div className={classes.category}>Main Invited Speakers</div>
            <Grid container style={{ padding: 16 }}>
              {renderInvitedSpeakers(InvirtedSpeakers)}
            </Grid>
          </div>
          <div className={classes.speakerOuter}>
            <div className={classes.category}>Invited Speakers</div>
            <div style={{ height: '100%', margin: '0 16px' }}>
              {SpeakerData && SpeakerData.length > 0 && (
                <Flicking plugins={_plugins} circular={true} style={{ width: '100%' }}>
                  <ViewportSlot>
                    <div className="flicking-arrow-prev" style={{ left: -20 }}></div>
                    <div className="flicking-arrow-next" style={{ right: -20 }}></div>
                  </ViewportSlot>
                  {SpeakerData && renderSpeakers(SpeakerData)}
                  <ViewportSlot>
                    <div className="flicking-pagination" />
                  </ViewportSlot>
                </Flicking>
              )}
            </div>
          </div>
        </div>
      </Grid>
    </>
  );
};

export default withTheme(MainSpeakersComponent);
